import { isRouteErrorResponse, useRouteError } from 'react-router'

import { APP_STATUS_ERROR } from '../../../constants/common'
import { ErrorPage } from '../ErrorPage'

// Route `errorElement` that shows the status the loader actually threw — a
// guard's 404 for a malformed uuid, or a not-found entity — instead of the
// blanket app error a hard-coded status gives. `ErrorPage` itself cannot read
// the route error: it is also rendered as a plain child outside any error
// boundary, where `useRouteError` would throw.
function RouteErrorPage() {
  const error = useRouteError()

  return (
    <ErrorPage
      status={isRouteErrorResponse(error) ? error.status : APP_STATUS_ERROR}
    />
  )
}

export default RouteErrorPage
